import { z } from 'zod';

export const videoExtractionZod = z.object({
  token: z.string(), // Swagger page for this is incorrect. Per Edvin, it's not nullable.
  name: z.string(), // Swagger page for this is incorrect. Per Edvin, it's not nullable.
  owner: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  logToken: z.string(), // Swagger page for this is incorrect. Per Edvin, it's not nullable.

  startTimestamp: z.number().int().nonnegative(),
  endTimestamp: z.number().int().nonnegative(),

  fileSize: z.number().int().nonnegative(),
  width: z.number().int().nonnegative(),
  height: z.number().int().nonnegative(),
  hz: z.number().int().nonnegative(),

  channel: z.nullable(z.string()),
  comments: z.nullable(z.string()),
  sampleGroupToken: z.string(),
  lidarExtractionToken: z.string().nullable(),
  attachmentTokens: z.nullable(z.string()),
  properties: z.nullable(z.string()),
  pipelineToken: z.string(),

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  lastAnnotatedAt: z.nullable(z.string().datetime()),
});

export const videoExtractionRespZod = z.array(videoExtractionZod);

export type VideoExtraction = z.infer<typeof videoExtractionZod>;
export type VideoExtractionResp = z.infer<typeof videoExtractionRespZod>;

export const isVideoExtraction = (
  extraction: unknown
): extraction is VideoExtraction =>
  videoExtractionZod.safeParse(extraction).success;
